import { render } from "./PartnersChatView.vue?vue&type=template&id=6927a786"
import script from "./PartnersChatView.vue?vue&type=script&lang=js"
export * from "./PartnersChatView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__